import React from "react";
import { Button, Icon } from "react-materialize";

export default function BtnAddMember() {
  return (
    <a
      href="/employees/profile/?tab=employeeinfo"
      target="_blank"
      rel="noreferrer"
    >
      <Button
        flat
        node="button"
        waves="light"
        className="btn-top-right textcolor-green"
        id="btn-addmember"
      >
        Add Member
        <Icon right>person_add</Icon>
      </Button>
    </a>
  );
}
